export default __webpack_public_path__ + "static/media/EVEREST_BETCLIC_FR.6e08224e.png";